import { UnmatchedPaymentsWithClients } from './models/unmatched-payments-with-clients.model';
import { UnmatchedPayment } from './models/unmatched-payment.model';
import { Document } from '../document-data/document.model';

// action interfaces
export interface IUnmatchedPayments {
  unmatchedPayments: UnmatchedPaymentsWithClients;
}

export interface IErrorPayload {
  error: any[] | Error;
}

export interface IMatchPaymentRequest {
  document: Document;
  payment: UnmatchedPayment;
  amountToMatch: number;
}

export interface IMatchPaymentSuccess extends IUnmatchedPayments {
  document: Document;
}

// action enums
export enum ActionsEnum {
  FETCH_UNMATCHED_PAYMENTS = 'FETCH_UNMATCHED_PAYMENTS',
  FETCH_UNMATCHED_PAYMENTS_SUCCESS = 'FETCH_UNMATCHED_PAYMENTS_SUCCESS',
  FETCH_UNMATCHED_PAYMENTS_ERROR = 'FETCH_UNMATCHED_PAYMENTS_ERROR',
  MATCH_PAYMENT = 'MATCH_PAYMENT',
  MATCH_PAYMENT_SUCCESS = 'MATCH_PAYMENT_SUCCESS',
  MATCH_PAYMENT_ERROR = 'MATCH_PAYMENT_ERROR',
}

export interface FetchUnmatchedPayments {
  type: ActionsEnum.FETCH_UNMATCHED_PAYMENTS;
}

export interface FetchUnmatchedPaymentsSuccess {
  type: ActionsEnum.FETCH_UNMATCHED_PAYMENTS_SUCCESS;
  payload: IUnmatchedPayments;
}

export interface FetchUnmatchedPaymentsError {
  type: ActionsEnum.FETCH_UNMATCHED_PAYMENTS_ERROR;
  payload: IErrorPayload;
}

export interface MatchPayment {
  type: ActionsEnum.MATCH_PAYMENT;
  payload: IMatchPaymentRequest;
}

export interface MatchPaymentSuccess {
  type: ActionsEnum.MATCH_PAYMENT_SUCCESS;
  payload: IMatchPaymentSuccess;
}

export interface MatchPaymentError {
  type: ActionsEnum.MATCH_PAYMENT_ERROR;
  payload: IErrorPayload;
}

// action definitions
export const fetchUnmatchedPayments = (): FetchUnmatchedPayments => ({
  type: ActionsEnum.FETCH_UNMATCHED_PAYMENTS,
});

export const fetchUnmatchedPaymentsSuccess = (
  unmatchedPayments: UnmatchedPaymentsWithClients
): FetchUnmatchedPaymentsSuccess => ({
  type: ActionsEnum.FETCH_UNMATCHED_PAYMENTS_SUCCESS,
  payload: {
    unmatchedPayments,
  },
});

export const fetchUnmatchedPaymentsError = (
  error: any[]
): FetchUnmatchedPaymentsError => ({
  type: ActionsEnum.FETCH_UNMATCHED_PAYMENTS_ERROR,
  payload: {
    error,
  },
});

export const matchPayment = (
  document: Document,
  payment: UnmatchedPayment,
  amountToMatch: number
): MatchPayment => ({
  type: ActionsEnum.MATCH_PAYMENT,
  payload: {
    document,
    payment,
    amountToMatch,
  },
});

export const matchPaymentSuccess = (
  document: Document,
  unmatchedPayments: UnmatchedPaymentsWithClients
): MatchPaymentSuccess => ({
  type: ActionsEnum.MATCH_PAYMENT_SUCCESS,
  payload: {
    document,
    unmatchedPayments,
  },
});

export const matchPaymentError = (error: any[]): MatchPaymentError => ({
  type: ActionsEnum.MATCH_PAYMENT_ERROR,
  payload: {
    error,
  },
});
